<!--
 * @Description: 
 * @Autor: wk
 * @Date: 2019-05-18 10:42:34
 * @LastEditors: lkz
 * @LastEditTime: 2021-12-02 17:00:02
 -->
<template>
  <div id="im-slider">
    <div class="slider_top">
      <img src="./yunjiLogo.png" />
      客服系统
    </div>
    <div>
      <div class="menulist">
        <!-- <div class="menulist_box">
            <span class="menulist_title" :class="{'activemenu':activeroute == '/work'}"><i class="el-icon-printer"></i><a href="/xinyunweb/work" target="_blank">工作台</a></span>
          </div>  -->

        <div
          class="menulist_box"
          v-for="(item, index) in list"
          :key="index"
          :class="{ showul: !item.showul }"
        >
          <span v-show="false">{{ item.showul }}</span>
          <p v-if="item.funcName == '首页'" :class="{ hidespan: !slideflg }">
            <i class="el-icon-setting"></i> <router-link target="_blank" to="/home">{{ item.funcName }}</router-link>
          </p>
          <p v-else @click="setslide(item)" :class="{ hidespan: !slideflg }">
            <i class="el-icon-setting"></i><span class="pzfont">{{ item.funcName }}</span>
            <label v-show="slideflg">
              <i class="el-icon-arrow-down" v-show="item.showul"></i>
              <i class="el-icon-arrow-up" v-show="!item.showul"></i>
            </label>
          </p>
          <ul :class="{ hidefont: !slideflg }">
            <li
              v-for="(item1, index1) in item.newchildIds"
              :key="index1"
              :class="{ activemenu: activeroute == item1.goto }"
            >
              <router-link target="_blank" :to="item1.goto">{{ item1.funcName }}</router-link>
            </li>
          </ul>
        </div>

        <!-- <div class="menulist_box" :class="{'showul':showul}" v-show="showpz">
            <p @click="showul = !showul"><i class="el-icon-setting"></i><span class="pzfont">配置管理</span>   
            <label v-show="slideflg"><i class="el-icon-arrow-down" v-show="!showul"></i>  <i class="el-icon-arrow-up" v-show="showul"></i></label>
            </p>
            <ul :class="{'hidefont':!slideflg}">
              <li v-for="(item,index) in silderlist.childIds" :key="index" :class="{'activemenu':activeroute == item.name}">
                <a :href="item.gourl" target="_blank">{{item.funcName}}</a>
              </li>
            </ul>
          </div>
          <div class="menulist_box showul" >
              <p ><i class="el-icon-setting"></i><span class="pzfont">会话管理</span> </p>
              <ul >
                <li>
                  <a href="/xinyunweb/session/session_service" target="_blank">服务记录管理</a>
                </li>
              </ul>
          </div> -->
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
import roleConfig from '../../utils/config/role.js'
import VueRouter from 'vue-router'
import router from '@/routers'
import * as http from './slider.service'

export default {
  name: 'im-slider',
  props: {
    slideflg: {
      type: Boolean
    }
  },
  data() {
    return {
      activeroute: '',
      list: [],
      data: {
        key: '1',
        name: '2'
      },
      showul: true,
      silderlist: [],
      showpz: false,
      showul2: true,
      flatMenu: []
    }
  },
  computed: {
    ...mapState({
      sessdatas: state => state.sessdatas
    })
  },
  watch: {
    $route(val) {
      this.activeroute = val.fullPath
    }
  },
  created() {
    this.getButtonAll()
  },
  mounted() {
    this.getqxian()
  },
  methods: {
    getqxian() {
      let timer = null
      http.menuAll().subscribe((res) => {
        if (res.response.data.errorCode === 0) {
          this.handleFlatMenu(res.response.data.data)
          this.cloudHandleData(res.response.data.data)
          this.permission()
          if (res.data && res.data.length) {
            // new promise处理是为了确保在生成菜单列表后每间隔20ms获取一次user信息，成功则返回接口，失败则继续获取持续100次即2s时间
            let count = 1
            new Promise((resolve) => {
              timer = setInterval(() => {
                if (count < 100) {
                  if (localStorage.getItem('users')) {
                    resolve(JSON.parse(localStorage.getItem('users')))
                  }
                } else {
                  resolve({})
                }
                count += 1
              }, 20)
            }).then((data) => {
              clearInterval(timer)
              timer = null
              if (res.data) {
                res.data[0].childIds.forEach((i) => {
                  i.showul = true
                  i.slideflg = true
                  if (i.childIds) {
                    i.newchildIds = []
                    i.childIds.forEach((j, k) => { // 剔除为button的元素，为页面按钮权限
                      if (j.functionType === 'menu') {
                        i.newchildIds.push(j)
                      }
                    })
                    i.newchildIds.forEach((j) => {
                      j.goto = j.functionUrl.substring(10)
                      // 针对工单链接特殊处理
                      if ((j.goto.includes('workOrderManagement') || j.goto.includes('taskManagement')) && data) {
                        const loginId = data.empId
                        j.goto = `${j.goto}?regionId=1&loginId=${loginId}`
                      }
                      if (j.goto.includes('eventlist') && data) {
                        j.goto = `${j.goto}?regionId=9&loginId=${data.empId}`
                      }
                    })
                  }
                })
              }
              this.list = res.data[0].childIds
            })
          }
          this.$store.dispatch('setdatas', this.data)
        } else {
          this.$message({
            showClose: 'true',
            message: res.errorMessage,
            type: 'error'
          })
        }
      })
    },
    setslide(item) {
      item.showul = !item.showul
    },
    gotoindex() {
      this.$router.push({ name: '/home' })
    },
    /** 获取按钮权限 */
    getButtonAll() {
      http.buttonAll().subscribe(
        (res) => {
          const obj = {}
          if (Array.isArray(res.data)) {
            res.data.map((item) => { obj[item] = true })
            this.$store.dispatch('setbuttonAll', obj)
          }
        }
      )
    },
    /** 
     * 处理数据
     */
    cloudHandleData(data) {
      // console.log(roleConfig)
      // console.log(window.location.pathname)

      // 如果是云集端，则跳过判断
      if (window.location.host === 't-do-dev.yunjiglobal.com' || window.location.host === 'xinyunadmin.yunjiglobal.com') return
      // 找不到，那就是二级路由，不进行判断
      if (roleConfig.findIndex(item => item === window.location.pathname) < 0) return 
      // 遍历menuAll，拿到全部的数据，拼成一维数组
      // let menuAll
      // const urlList = ['/xinyunweb', '/xinyunweb/', '/xinyunweb/work']
      try {
        // menuAll = data[0].childIds
        // menuAll.forEach((item) => {
        //   if (item.functionUrl) urlList.push(item.functionUrl)
        //   item.childIds.forEach((value) => {
        //     if (value.functionUrl) urlList.push(value.functionUrl)
        //   }) 
        // })
        // if (urlList.findIndex(item => item === window.location.pathname) < 0) {
        //   // 找不到，那就是没有权限
        //   window.location.href = '/xinyunweb/login'
        // } 
        this.flatMenu.push('/xinyunweb', '/xinyunweb/', '/xinyunweb/work')
        if (this.flatMenu.findIndex(item => item === window.location.pathname) < 0) {
          // 找不到，那就是没有权限
          window.location.href = '/xinyunweb/login'
        } 
      } catch (e) {
        console.log(e)
      }
    },
    handleFlatMenu(data) {
      try {
        const flatMenu = []
        const menuAll = data[0].childIds
        menuAll.forEach((item) => {
          if (item.functionUrl) flatMenu.push(item.functionUrl)
          item.childIds.forEach((value) => {
            if (value.functionUrl) flatMenu.push(value.functionUrl)
          }) 
        })
        this.flatMenu = flatMenu
      } catch (e) {
        // console.log(e)
      }
    },
    permission() {
      const permission = ['/xinyunweb/workMenu/generalQuery/searchIndex']
      if (
        this.flatMenu.findIndex(item => item === window.location.pathname) < 0 
        && permission.findIndex(item => item === window.location.pathname) > -1
      ) window.location.href = 'http://sso.yunjiglobal.com'
    }
  }
}
</script>
<style lang="less">
@import '~styles/var.less';

#im-slider {
  background: #358bcc;
  color: #fff;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  .showul {
    ul {
      height: auto;
    }
  }

  .showbox {
    a,
    .pzfont {
      display: none;
    }
  }
}
#im-slider::-webkit-scrollbar {
  width: 4px;
}
#im-slider::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #cce9ff;
}
.el-menu {
  background: #358bcc !important;
  border: none !important;
  text-align: left;
  i {
    color: #fff !important;
    display: inline-block;
    margin-right: 10px;
  }
  .is-active,
  .el-menu-item:hover,
  .el-submenu__title:focus,
  .el-submenu__title:hover,
  .el-menu-item:focus,
  .el-menu-item:hover {
    background: #2a75ad !important;
  }
  .el-menu-item.is-active {
    color: #fff;
  }
  span {
    font-size: 14px !important;
  }
}
.el-menu-item.is-active {
  color: #fff;
  background: #2a75ad !important;
}
.slider_top {
  background: #284d68;
  height: 59px;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #ffffff;
  img {
    width: 24px;
    height: 24px;
    display: inline-block;
    margin: 0 6px 0 16px;
  }
}

.menulist_title,
.menulist_box p {
  display: block;
  text-align: center;
  font-size: 14px;
  line-height: 56px;
  cursor: pointer;
  margin: 0;
  text-align: left;
  padding-left: 20px;
}
.menulist_box {
  overflow: hidden;
  i {
    display: inline-block;
    margin-right: 10px;
  }
  a {
    color: #fff;
  }
  ul {
    height: 0;
    transition: all 0.5s ease;
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      text-align: center;
      line-height: 56px;
      font-size: 14px;
      a {
        display: block;
        text-align: left;
        padding-left: 43px;
      }
    }
  }
  .activemenu {
    background: #2a75ad !important;
  }
  .hidefont {
    a {
      display: none !important;
    }
  }
  .hidespan {
    span {
      display: none;
    }
    a {
      display: none;
    }
  }
}
</style>

